import axios from "axios";
import { baseUrl, headers } from "../config/env";

// // 회원 관리
export function fetchUserList(params) {
  return axios.get(baseUrl + `/admin/user/list`, { params, headers });
}
export function fetchUserWordList(params) {
  return axios.get(baseUrl + `/admin/user/word`, { params, headers });
}

export function fetchUserDetails(id) {
  return axios.get(baseUrl + `/admin/user/${id}`, { headers });
}

export function updateUserDetails(data) {
  return axios.put(baseUrl + `/admin/user`, data, { headers });
}

// 대시보드
export function fetchDashboardList() {
  return axios.get(baseUrl + `/admin/dashboard`, { headers });
}

export function fetchDashboardWordList(params) {
  return axios.get(baseUrl + `/admin/dashboard/word`, { params, headers });
}
